module.exports = __webpack_public_path__ + "static/media/49.d9bcdbda.png";